export default "https://cdn-static.gokick.com/assets/ac567471f1b9fb2f6cedfba22f3391469dbaa38e/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";